module.exports = __webpack_public_path__ + "static/media/success-icon.bdddd460.svg";